import { Link } from '@/components/ui/link';

import { useLanguage } from '@/i18n/language-context';

export const Brand = (): JSX.Element => {
  const { t } = useLanguage();
  return (
    <Link appearance="bare" className="brand" to="/" aria-label={t.brandHome}>
      <img src="/brand/mark.svg" alt="" width="46" height="46" />
      <span>
        <strong>{t.appName}</strong> <small>{t.unionName}</small>
      </span>
    </Link>
  );
};
